module.exports = __webpack_public_path__ + "img/album15_04.5aacc95f.jpg";